module.exports = __webpack_public_path__ + "static/b1-rtj-ab015a28a537405ce21fc6e931d5beb0.jpg";